import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useOwnerData = () => {
  return useQuery({
    queryKey: ["ownerData"],
    queryFn: async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          console.error("No user found");
          throw new Error("Non authentifié");
        }

        console.log("Current user ID:", user.id);

        // If user is an owner_user, use their reference_owner_id instead
        const ownerId = user.user_metadata?.reference_owner_id || user.id;
        console.log("Using owner ID:", ownerId);

        const { data: ownerDataResult, error: ownerError } = await supabase
          .from("owner_data")
          .select("*, business_types (id, name, description)")
          .eq("owner_id", ownerId)
          .maybeSingle();

        if (ownerError) {
          console.error("Error fetching owner data:", ownerError);
          toast.error("Erreur lors du chargement des données");
          throw ownerError;
        }

        if (!ownerDataResult) {
          console.log("No owner data found");
          toast.error("Aucune donnée trouvée pour votre profil");
          return null;
        }

        console.log("Owner data retrieved:", ownerDataResult);
        return ownerDataResult;
      } catch (error) {
        console.error("Error in owner data query:", error);
        toast.error("Erreur lors du chargement des données");
        throw error;
      }
    },
  });
};